module.exports = __webpack_public_path__ + "img/xizi_lucy_wang_web_logo_word.bf22b470.png";